import React from "react";
import { Layout } from "antd";

const ClientMainLayout = ({ className, ...props }) => {
  return <Layout className={`${className}`}>{props.children}</Layout>;
};

export default ClientMainLayout;
